import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import menunavidad1 from "../assets/theme-images/menunavidad1.jpeg";
import menunavidad2 from "../assets/theme-images/menunavidad2.jpeg";
import Navbar from "../components/Navbar/Navbar";

export default function Navidad() {
  // He invertido el orden: menunavidad2 primero
  const images = [
    { id: 2, src: menunavidad2, alt: "Menú Navideño 1" },
    { id: 1, src: menunavidad1, alt: "Menú Navideño 2" },
  ];

  const [modalOpen, setModalOpen] = useState(false);
  const [current, setCurrent] = useState(images[0]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setModalOpen(false);
      if (e.key === "ArrowRight" && modalOpen) {
        setCurrent((prev) => {
          const idx = images.findIndex((i) => i.id === prev.id);
          return images[(idx + 1) % images.length];
        });
      }
      if (e.key === "ArrowLeft" && modalOpen) {
        setCurrent((prev) => {
          const idx = images.findIndex((i) => i.id === prev.id);
          return images[(idx - 1 + images.length) % images.length];
        });
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [modalOpen, images]);

  const openModal = (img) => {
    setCurrent(img);
    setModalOpen(true);
  };

  const downloadImage = (src, filename) => {
    const a = document.createElement("a");
    a.href = src;
    a.download = filename || "menu-navidad.jpeg";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div
      className="min-h-screen bg-fixed bg-cover bg-center"
      style={{ backgroundColor: "#f8f7f5" }}
    >
      {/* Navbar para volver al inicio */}
      <Navbar />

      <div className="max-w-6xl mx-auto px-6 py-10">
        {/* Header */}
        <header className="mb-8 text-center">
            <br/>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1f3b24]">
            Menús de Navidad
          </h1>
          <p className="mt-2 text-sm text-gray-600 max-w-2xl mx-auto">
            Haz clic en la imagen para ampliar o descargar.
          </p>
        </header>

        {/* Grid de imágenes */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {images.map((img) => (
            <motion.article
              key={img.id}
              className="rounded-2xl overflow-hidden bg-white shadow-lg border border-[#efe9df]"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, ease: "easeOut" }}
            >
              <div className="relative">
                <button
                  onClick={() => openModal(img)}
                  className="block w-full focus:outline-none"
                  aria-label={`Ampliar ${img.alt}`}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-auto object-contain md:h-[720px] select-none"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </button>

                <div className="absolute bottom-4 left-4 flex gap-2">
                  <button
                    onClick={() =>
                      downloadImage(img.src, `menu-navidad-${img.id}.jpeg`)
                    }
                    className="text-xs px-3 py-1 bg-[#faf4ec] text-[#503a2c] rounded-md border shadow-sm hover:bg-[#C19B50] hover:text-white transition"
                  >
                    Descargar
                  </button>
                  {/* botón imprimir eliminado por petición */}
                </div>
              </div>

              {/* tarjeta con breve nota (se mantiene en la vista en miniatura) */}
              <div className="p-4 md:p-6 bg-gradient-to-t from-white/50 to-transparent">
                <h3 className="text-lg font-semibold text-[#503a2c]">
                  {img.alt}
                </h3>
                <p className="mt-1 text-sm text-gray-600">
                </p>
              </div>
            </motion.article>
          ))}
        </section>
      </div>

      {/* Modal / Lightbox (sin texto; con borde estético) */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-60 flex items-center justify-center bg-black/60 p-4"
          role="dialog"
          aria-modal="true"
        >
          <motion.div
            className="relative max-w-[95vw] max-h-[95vh] rounded-xl overflow-hidden bg-black"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            {/* Borde decorativo exterior */}
            <div
              className="rounded-xl p-1"
              style={{
                background:
                  "linear-gradient(180deg, rgba(186,145,61,0.95), rgba(186,145,61,0.6))",
              }}
            >
              <div className="rounded-lg overflow-hidden bg-white">
                {/* Close */}
                <button
                  onClick={() => setModalOpen(false)}
                  className="absolute top-3 right-3 z-50 bg-white/90 text-[#503a2c] rounded-full w-9 h-9 flex items-center justify-center shadow"
                  aria-label="Cerrar"
                >
                  ✕
                </button>

                {/* Prev / Next */}
                <button
                  onClick={() =>
                    setCurrent((prev) => {
                      const idx = images.findIndex((i) => i.id === prev.id);
                      return images[(idx - 1 + images.length) % images.length];
                    })
                  }
                  className="absolute left-2 top-1/2 -translate-y-1/2 z-40 text-white/90 bg-black/40 rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/60"
                  aria-label="Anterior"
                >
                  ‹
                </button>
                <button
                  onClick={() =>
                    setCurrent((prev) => {
                      const idx = images.findIndex((i) => i.id === prev.id);
                      return images[(idx + 1) % images.length];
                    })
                  }
                  className="absolute right-2 top-1/2 -translate-y-1/2 z-40 text-white/90 bg-black/40 rounded-full w-10 h-10 flex items-center justify-center hover:bg-black/60"
                  aria-label="Siguiente"
                >
                  ›
                </button>

                {/* Imagen grande con borde interior y padding para estética */}
                <div className="max-w-[90vw] max-h-[80vh] p-4 flex items-center justify-center bg-[#f8f7f5]">
                  <img
                    src={current.src}
                    alt={current.alt}
                    className="block max-w-full max-h-[72vh] mx-auto object-contain rounded-md shadow-md border-4 border-white"
                    style={{ boxShadow: "0 10px 30px rgba(0,0,0,0.35)" }}
                  />
                </div>

                {/* Acciones: solo descargar (imprimir eliminado) */}
                <div className="p-4 flex items-center justify-end bg-gradient-to-t from-black/20 to-transparent">
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() =>
                        downloadImage(
                          current.src,
                          `menu-navidad-${current.id}.jpeg`
                        )
                      }
                      className="px-3 py-1 bg-[#faf4ec] text-[#503a2c] rounded-md shadow hover:bg-[#C19B50] hover:text-white transition"
                    >
                      Descargar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}
